// import * as React from 'react';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import {
//   Box,
//   FormControl,
//   IconButton,
//   InputAdornment,
//   TableContainer,
//   TextField,
//   Typography,
// } from '@mui/material';
// import FilterAltIcon from '@mui/icons-material/FilterAlt';
// import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import SearchIcon from '@mui/icons-material/Search';

// import classes from './TableComponent.module.css';
// import { ManageColumnComponents } from './ManageComponent';

// const TableComponent = ({
//   columns,
//   rows,
//   manageColumnStatus,
//   size,
//   enableSort,
//   rowClickHandler,
// }) => {
//   const [selectedColumns, setSelectedColumns] = React.useState(columns);
//   const [searchValues, setSearchValues] = React.useState({});
//   const [filteredRows, setFilteredRows] = React.useState(rows);
//   const [sortedRows, setSortedRows] = React.useState(rows);
//   const [sortDirection, setSortDirection] = React.useState(0);
//   const [enableAdvanceFilter, setEnabledAdvanceFilter] = React.useState(0);
//   const [enableAdvanceFilterDirection, setEnabledAdvanceFilterDirection] =
//     React.useState(0);

//   React.useEffect(() => {
//     setFilteredRows(rows);
//     setSortedRows(rows);
//   }, [rows]);

//   const handleColumnChange = (newColumns) => {
//     setSelectedColumns(newColumns);
//   };

//   const sortedColumns = [...selectedColumns].sort((a, b) => a.id - b.id);

//   // Handle advanced column search inputs
//   const handleSearchChange = (field, value) => {
//     setSearchValues((prevSearchValues) => ({
//       ...prevSearchValues,
//       [field]: value?.trim(),
//     }));
//   };

//   React.useEffect(() => {
//     const newFilteredRows = sortedRows.filter((row) =>
//       sortedColumns.every((column) => {
//         const columnValue = row[column.field];
//         const searchValue = searchValues[column.field]?.trim();
//         return (
//           !searchValue ||
//           (columnValue &&
//             columnValue
//               .toString()
//               .toLowerCase()
//               .includes(searchValue.toLowerCase()))
//         );
//       })
//     );
//     setFilteredRows(newFilteredRows);
//   }, [sortedRows, selectedColumns, searchValues]);

//   // Sorting handler
//   const onSortClick = (columnField) => {
//     let sortedRow;
//     const currentColumn = sortedColumns.find(
//       (col) => col.field === columnField
//     );

//     if (currentColumn?.type === 'number') {
//       if (sortDirection === 0) {
//         sortedRow = [...filteredRows].sort(
//           (a, b) => b[columnField] - a[columnField]
//         );
//         setSortDirection(1);
//         setSortedRows(sortedRow);
//       } else if (sortDirection === 1) {
//         sortedRow = [...filteredRows].sort(
//           (a, b) => a[columnField] - b[columnField]
//         );
//         setSortDirection(2);
//         setSortedRows(sortedRow);
//       } else {
//         setSortDirection(0);
//         setFilteredRows(rows);
//       }
//     } else {
//       if (sortDirection === 0) {
//         sortedRow = [...filteredRows].sort((a, b) =>
//           a[columnField]?.toString().localeCompare(b[columnField]?.toString())
//         );
//         setSortDirection(1);
//         setSortedRows(sortedRow);
//       } else if (sortDirection === 1) {
//         sortedRow = [...filteredRows].sort((a, b) =>
//           b[columnField]?.toString().localeCompare(a[columnField]?.toString())
//         );
//         setSortDirection(2);
//         setSortedRows(sortedRow);
//       } else {
//         setSortDirection(0);
//         setFilteredRows(rows);
//       }
//     }
//   };

//   // Global search handler
//   const handleGlobalSearch = (event) => {
//     const searchValue = event.target.value;
//     const newGlobalFilteredRows = rows.filter((row) =>
//       sortedColumns.some((column) => {
//         const columnValue = row[column.field];
//         return columnValue
//           ?.toString()
//           .toLowerCase()
//           .includes(searchValue?.trim().toLowerCase());
//       })
//     );
//     setSortedRows(newGlobalFilteredRows);
//   };

//   // Toggle advanced filter inputs
//   const handleAdvancedFilter = () => {
//     if (enableAdvanceFilterDirection === 0) {
//       setEnabledAdvanceFilter(1);
//       setEnabledAdvanceFilterDirection(1);
//     } else {
//       setEnabledAdvanceFilter(0);
//       setEnabledAdvanceFilterDirection(0);
//     }
//   };

//   return (
//     <>
//       <TableContainer component={Paper}>
//         {manageColumnStatus && (
//           <Box className={classes.tableHeader}>
//             <Box>
//               <FormControl
//                 sx={{
//                   m: 1.5,
//                   width: '65ch',
//                   '@media (max-width: 870px)': { width: '45ch' },
//                   '@media (max-width: 570px)': { width: '23ch' },
//                 }}
//               >
//                 <TextField
//                   type="text"
//                   label="Search"
//                   placeholder="Search..."
//                   onChange={handleGlobalSearch}
//                   InputProps={{
//                     endAdornment: (
//                       <InputAdornment position="end">
//                         <SearchIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </FormControl>
//             </Box>
//             <Box className={classes.rightIconContainer}>
//               <IconButton
//                 className={classes.filterIconContainer}
//                 onClick={handleAdvancedFilter}
//               >
//                 <FilterAltIcon className={classes.advancedFilterIcon} />
//               </IconButton>
//               <ManageColumnComponents
//                 columns={columns}
//                 selectedColumns={selectedColumns}
//                 onColumnChange={handleColumnChange}
//               />
//             </Box>
//           </Box>
//         )}

//         <Table size={size}>
//           <TableHead>
//             <TableRow>
//               {sortedColumns.map((column) => (
//                 <TableCell width={column?.width} key={column.id}>
//                   <Box className={classes.tableCellContainer}>
//                     {enableSort ? (
//                       <>
//                         <Typography
//                           onClick={() => onSortClick(column.field)}
//                           className={classes.tableCellContainerItems}
//                           sx={{ cursor: 'pointer' }}
//                         >
//                           {column.headerName}
//                         </Typography>
//                         {sortDirection === 1 && (
//                           <ArrowDownwardIcon className={classes.sortIcon} />
//                         )}
//                         {sortDirection === 2 && (
//                           <ArrowUpwardIcon className={classes.sortIcon} />
//                         )}
//                       </>
//                     ) : (
//                       <Typography>{column.headerName}</Typography>
//                     )}
//                   </Box>
//                 </TableCell>
//               ))}
//             </TableRow>
//           </TableHead>

//           <TableHead>
//             <TableRow>
//               {enableAdvanceFilter === 1 &&
//                 sortedColumns.map((column) => (
//                   <TableCell key={column.id}>
//                     <TextField
//                       size="small"
//                       placeholder="Search..."
//                       value={searchValues[column.field] || ''}
//                       onChange={(e) =>
//                         handleSearchChange(column.field, e.target.value)
//                       }
//                     />
//                   </TableCell>
//                 ))}
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {filteredRows.length > 0 ? (
//               filteredRows.map((row, rowIndex) => (
//                 <TableRow
//                   sx={{ cursor: 'pointer' }}
//                   component={Paper}
//                   key={rowIndex}
//                   onClick={() => (rowClickHandler ? rowClickHandler(row.id) : null)}
//                 >
//                   {sortedColumns.map((column) => (
//                     <TableCell align="left" key={column.id}>
//                       {column.renderCell
//                         ? column.renderCell({ value: row[column.field], row })
//                         : row[column.field]}
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               ))
//             ) : (
//               <TableRow>
//                 <TableCell colSpan={sortedColumns.length} align="center">
//                   <Typography>No Data!</Typography>
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </>
//   );
// };

// export default TableComponent;





import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SearchIcon from '@mui/icons-material/Search';

import classes from './TableComponent.module.css';
import { ManageColumnComponents } from './ManageComponent';

const TableComponent = ({
  columns,
  rows,
  manageColumnStatus,
  size,
  enableSort,
  rowClickHandler,
}) => {
  const [selectedColumns, setSelectedColumns] = React.useState(columns);
  const [searchValues, setSearchValues] = React.useState({});
  const [filteredRows, setFilteredRows] = React.useState(rows);
  const [sortedRows, setSortedRows] = React.useState(rows);
  const [sortDirection, setSortDirection] = React.useState(0);
  const [enableAdvanceFilter, setEnabledAdvanceFilter] = React.useState(0);
  const [enableAdvanceFilterDirection, setEnabledAdvanceFilterDirection] =
    React.useState(0);

  // Pagination state
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  React.useEffect(() => {
    setFilteredRows(rows);
    setSortedRows(rows);
    setPage(0); // Reset page when rows change
  }, [rows]);

  const handleColumnChange = (newColumns) => {
    setSelectedColumns(newColumns);
  };

  const sortedColumns = [...selectedColumns].sort((a, b) => a.id - b.id);

  // Handle advanced column search inputs - store raw value including spaces
  const handleSearchChange = (field, value) => {
    setSearchValues((prevSearchValues) => ({
      ...prevSearchValues,
      [field]: value, // store raw input value without trim here
    }));
  };

  React.useEffect(() => {
    const newFilteredRows = sortedRows.filter((row) =>
      sortedColumns.every((column) => {
        const columnValue = row[column.field];
        const searchValue = searchValues[column.field]?.trim(); // trim at comparison time
        return (
          !searchValue ||
          (columnValue &&
            columnValue
              .toString()
              .toLowerCase()
              .includes(searchValue.toLowerCase()))
        );
      })
    );
    setFilteredRows(newFilteredRows);
    setPage(0); // Reset to first page when filtering changes
  }, [sortedRows, selectedColumns, searchValues]);

  // Sorting handler
  const onSortClick = (columnField) => {
    let sortedRow;
    const currentColumn = sortedColumns.find(
      (col) => col.field === columnField
    );

    if (currentColumn?.type === 'number') {
      if (sortDirection === 0) {
        sortedRow = [...filteredRows].sort(
          (a, b) => b[columnField] - a[columnField]
        );
        setSortDirection(1);
        setSortedRows(sortedRow);
      } else if (sortDirection === 1) {
        sortedRow = [...filteredRows].sort(
          (a, b) => a[columnField] - b[columnField]
        );
        setSortDirection(2);
        setSortedRows(sortedRow);
      } else {
        setSortDirection(0);
        setFilteredRows(rows);
      }
    } else {
      if (sortDirection === 0) {
        sortedRow = [...filteredRows].sort((a, b) =>
          a[columnField]?.toString().localeCompare(b[columnField]?.toString())
        );
        setSortDirection(1);
        setSortedRows(sortedRow);
      } else if (sortDirection === 1) {
        sortedRow = [...filteredRows].sort((a, b) =>
          b[columnField]?.toString().localeCompare(a[columnField]?.toString())
        );
        setSortDirection(2);
        setSortedRows(sortedRow);
      } else {
        setSortDirection(0);
        setFilteredRows(rows);
      }
    }
  };

  // Global search handler
  const handleGlobalSearch = (event) => {
    const searchValue = event.target.value;
    const newGlobalFilteredRows = rows.filter((row) =>
      sortedColumns.some((column) => {
        const columnValue = row[column.field];
        return columnValue
          ?.toString()
          .toLowerCase()
          .includes(searchValue?.trim().toLowerCase());
      })
    );
    setSortedRows(newGlobalFilteredRows);
    setPage(0);
  };

  // Toggle advanced filter inputs
  const handleAdvancedFilter = () => {
    if (enableAdvanceFilterDirection === 0) {
      setEnabledAdvanceFilter(1);
      setEnabledAdvanceFilterDirection(1);
    } else {
      setEnabledAdvanceFilter(0);
      setEnabledAdvanceFilterDirection(0);
    }
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Rows to be displayed in the current page
  const displayedRows = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <TableContainer component={Paper}>
        {manageColumnStatus && (
          <Box className={classes.tableHeader}>
            <Box>
              <FormControl
                sx={{
                  m: 1.5,
                  width: '65ch',
                  '@media (max-width: 870px)': { width: '45ch' },
                  '@media (max-width: 570px)': { width: '23ch' },
                }}
              >
                <TextField
                  type="text"
                  label="Search"
                  placeholder="Search..."
                  onChange={handleGlobalSearch}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </Box>
            <Box className={classes.rightIconContainer}>
              <IconButton
                className={classes.filterIconContainer}
                onClick={handleAdvancedFilter}
              >
                <FilterAltIcon className={classes.advancedFilterIcon} />
              </IconButton>
              <ManageColumnComponents
                columns={columns}
                selectedColumns={selectedColumns}
                onColumnChange={handleColumnChange}
              />
            </Box>
          </Box>
        )}

        <Table size={size}>
          <TableHead>
            <TableRow>
              {sortedColumns.map((column) => (
                <TableCell width={column?.width} key={column.id}>
                  <Box className={classes.tableCellContainer}>
                    {enableSort ? (
                      <>
                        <Typography
                          onClick={() => onSortClick(column.field)}
                          className={classes.tableCellContainerItems}
                          sx={{ cursor: 'pointer' }}
                        >
                          {column.headerName}
                        </Typography>
                        {sortDirection === 1 && (
                          <ArrowDownwardIcon className={classes.sortIcon} />
                        )}
                        {sortDirection === 2 && (
                          <ArrowUpwardIcon className={classes.sortIcon} />
                        )}
                      </>
                    ) : (
                      <Typography>{column.headerName}</Typography>
                    )}
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableHead>
            <TableRow>
              {enableAdvanceFilter === 1 &&
                sortedColumns.map((column) => (
                  <TableCell key={column.id}>
                    <TextField
                      size="small"
                      placeholder="Search..."
                      value={searchValues[column.field] || ''}
                      onChange={(e) =>
                        handleSearchChange(column.field, e.target.value)
                      }
                    />
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {displayedRows.length > 0 ? (
              displayedRows.map((row, rowIndex) => (
                <TableRow
                  sx={{ cursor: 'pointer' }}
                  component={Paper}
                  key={rowIndex}
                  onClick={() => (rowClickHandler ? rowClickHandler(row.id) : null)}
                >
                  {sortedColumns.map((column) => (
                    <TableCell align="left" key={column.id}>
                      {column.renderCell
                        ? column.renderCell({ value: row[column.field], row })
                        : row[column.field]}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={sortedColumns.length} align="center">
                  <Typography>No Data!</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 500, 1000, 5000, 10000, 50000, 100000]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </>
  );
};

export default TableComponent;
